import React from 'react';
import {connect} from "react-redux";
// import {Link} from 'react-router';
import classNames from 'classnames';
import moment from 'moment';
import actions from '../../actions/index';
import constants from '../../constants';

const {STATISTIC_TYPE} = constants;

const {getLiveAttendees, getRecordedViews} = actions;

const StatsListItem = ({
  item,
  getLiveAttendeesAction,
  getRecordedViewsAction,
  // user,
}) => {
  const handleLiveClick = () => {
    // if (user.sponsor_type === 'private_hospital')
      getLiveAttendeesAction({
        ...item,
        type: STATISTIC_TYPE.ATTENDED,
      });
  };
  const handleRecordedClick = () => {
    // if (user.sponsor_type === 'private_hospital')
      getRecordedViewsAction({
        ...item,
        type: STATISTIC_TYPE.VIEWED,
      });
  };
  const handleClickPPT = () => {
    if (item.ppt_document_url)
      window.open(item.ppt_document_url);
  };
  const handleClickEvaluationSummary = () => {
    if (item.evaluation_summary_url)
      window.open(item.evaluation_summary_url);
  };
  const vimeoUrl = item.vimeo_url ? `https://player.vimeo.com/video/${(item.vimeo_url || '').replace('/', '?h=')}` : '';
  const handleVideoClick = () => {
    window.open(vimeoUrl, '_blank');
  };
  return (
    <tr>
      <td className='stats_item_title' style={{textAlign: 'center'}}>
        {item.start_date ? moment(item.start_date).format('D/M/YYYY') : 'Record'}
        <span>
          {item.start_date ? ` ${moment(item.start_date).format('h:mm a').toUpperCase()}` : ''}
        </span>
      </td>
      <td className="stats_item_title" style={{textAlign: 'center'}}>{item.webinar_title}</td>
      <td
        className={classNames("stats_item_text", {
          not_available: !vimeoUrl,
        })}
        onClick={handleVideoClick}
      >
        {vimeoUrl || 'Not Available'}
      </td>
      <td className="stats_item_title" style={{textAlign: 'center'}}>
        {item.registered_users_count}
      </td>
      <td
        className={classNames("stats_item_text", {
          // not_available: user.sponsor_type !== 'private_hospital'
        })}
        onClick={handleLiveClick}
      >
        {item.attended_count}
      </td>
      <td
        className={classNames("stats_item_text", {
          // not_available: user.sponsor_type !== 'private_hospital'
        })}
        onClick={handleRecordedClick}
      >
        {item.views_count}
      </td>
      <td
        className={classNames("stats_item_text", {
        })}
        onClick={() => {}}
      >
        {item.in_person_count}
      </td>
      {/* <td
        className={classNames("stats_item_text", {
          not_available: !item.evaluation_summary_url,
        })}
        onClick={handleClickEvaluationSummary}
      >
        {item.evaluation_summary_url ? 'Download' : 'Not Available'}
      </td> */}
      {/* <td className="stats_item_text">
        <Link
          className="stats_item_button"
          to={`/data-visualisation/${item.id}`}
        >
          View
        </Link>
      </td> */}
    </tr>
  );
};

const mapDispatchToProps = dispatch => ({
  getLiveAttendeesAction: workshop_id => dispatch(getLiveAttendees(workshop_id)),
  getRecordedViewsAction: workshop_id => dispatch(getRecordedViews(workshop_id)),
});

export default connect(null, mapDispatchToProps)(StatsListItem);



// WEBPACK FOOTER //
// ./src/components/StatsLocker/ListItem.js